import { __t } from '@/lib/helpers.js'
import { ACCESS_LEVELS, WEBVIEW_TYPES } from '@/lib/consts.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'
import { useGdprAgreements } from '@/components/onboarding/composables/gdpr-agreements/index.js'

export default {
  path: 'booksy-app',
  name: 'settings.booksy-app',
  meta: {
    title: __t('routes.settings.booksy-app.title'),
    subtitle: __t('routes.settings.booksy-app.subtitle'),
    icon: 'booksy-app',
    backgroundIcon: 'booksy-app',
  },
  component: () => import('@/views/business/settings/booksy-app/index.vue'),
  children: [
    {
      path: 'agreement',
      name: 'settings.booksy-app.agreement',
      meta: {
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: () => (false),
      },
      component: () => import('@/views/business/settings/booksy-app/agreement.vue'),
    },
    {
      path: 'privacy',
      name: 'settings.booksy-app.privacy',
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.MANAGER,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          const { isUSMarketingConsentEnabled } = useGdprAgreements()
          return !!store.state.routingConfig.config.gdpr || isUSMarketingConsentEnabled.value
        },
        title: __t('routes.settings.booksy-app.privacy.title'),
      },
      component: () => import('@/views/business/settings/booksy-app/privacy/index.vue'),
    },
    {
      path: 'licenses',
      name: 'settings.booksy-app.licenses',
      meta: {
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          return !!store.state.app.webView
        },
        title: __t('routes.settings.booksy-app.licenses.title'),
      },
      component: () => import('@/views/business/settings/booksy-app/licenses.vue'),
    },
    {
      path: 'privacy-policy-terms-of-use',
      name: 'settings.booksy-app.privacy-policy-terms-of-use',
      meta: {
        title: __t('routes.settings.booksy-app.privacy-policy-terms-of-use.title'),
      },
      component: () => import('@/views/business/settings/booksy-app/terms-of-use.vue'),
    },
    {
      path: 'privacy-policy',
      name: 'settings.booksy-app.privacy-policy',
      meta: {
        title: __t('routes.settings.booksy-app.privacy-policy.title'),
      },
      component: () => import('@/views/business/settings/booksy-app/privacy-policy.vue'),
    },
    {
      path: 'delete-your-account',
      name: 'settings.booksy-app.delete-your-account',
      meta: {
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          return store.state.app.webView === WEBVIEW_TYPES.IOS || store.state.app.webView === WEBVIEW_TYPES.ANDROID
        },
        title: __t('routes.settings.booksy-app.delete-your-account.title'),
      },
      component: () => import('@/views/business/settings/booksy-app/delete-your-account.vue'),
    },
  ],
}
